export default function useUrlParams() {
  const params = new URLSearchParams(window.location.search)

  return {
    params
  }
}